
import Code from "../../../assets/outline/Code.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CodeIcon({ className, dataTestid = "CodeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Code data-testid={dataTestid} className={classes} {...rest} />
  );
}
